import { render, staticRenderFns } from "./SupportNav.vue?vue&type=template&id=19dde5f0&scoped=true&"
import script from "./SupportNav.vue?vue&type=script&lang=js&"
export * from "./SupportNav.vue?vue&type=script&lang=js&"
import style0 from "./SupportNav.vue?vue&type=style&index=0&id=19dde5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dde5f0",
  null
  
)

export default component.exports